export type Talk = {
  id: string; // YouTube video ID
  url: string;
  topic: string; // Konu
  program: string; // Program / Konferans / Yayın
  date: string; // ISO YYYY-MM-DD
};

// En yeni en üstte sıralanır
export const talks: Talk[] = [
  {
    id: "acNLca049kg",
    url: "https://www.youtube.com/watch?v=acNLca049kg",
    topic: "Yapay Zekâyı Yeniden Tasarlamak",
    program: "Future AI Summit'26 — Redesign Intelligence",
    date: "2026-06-23",
  },
  {
    id: "wjvCkm3quxo",
    url: "https://www.youtube.com/watch?v=wjvCkm3quxo",
    topic: "İnsanın Anlamını Kim Koruyacak?",
    program: "Harvard Business Review Türkiye",
    date: "2026-06-06",
  },
  {
    id: "GuNOF7mNeTY",
    url: "https://www.youtube.com/watch?v=GuNOF7mNeTY",
    topic: "Sürdürülebilirlik ve Geleceği Tasarlamak",
    program: "Yapı Kredi — Sürdürülebilirlik Sohbetleri #100",
    date: "2026-04-27",
  },
  {
    id: "lYh5nRhzxlo",
    url: "https://www.youtube.com/watch?v=lYh5nRhzxlo",
    topic: "Yapay Zekâ ve İnsana Etkisi",
    program: "Colors of Marketing",
    date: "2026-02-20",
  },
  {
    id: "RA91bbVPpO0",
    url: "https://www.youtube.com/watch?v=RA91bbVPpO0",
    topic: "Yapay Zekâ, Finans ve Sürdürülebilirlik",
    program: "Finansal Teknoloji",
    date: "2025-10-15",
  },
  {
    id: "IemWHkGqkMk",
    url: "https://www.youtube.com/watch?v=IemWHkGqkMk",
    topic: "Yapay Zekâ İnsanlığa Karşı Gelir mi? Geleceğin Bankaları Nasıl Olacak?",
    program: "Duygu Demirdağ ile Söyleşi",
    date: "2025-03-12",
  },
  {
    id: "iCmSeIaQZjU",
    url: "https://www.youtube.com/watch?v=iCmSeIaQZjU",
    topic: "Geleceğin Finans Dünyasında AI ve Sürdürülebilirlik",
    program: "SKD Türkiye — X. Sürdürülebilir Finans Forumu",
    date: "2024-12-11",
  },
  {
    id: "222vmSGPSgg",
    url: "https://www.youtube.com/watch?v=222vmSGPSgg",
    topic: "İklim Değil, İnsanlık Krizi",
    program: "Harvard Business Review Türkiye",
    date: "2024-12-04",
  },
  {
    id: "yY3NSezaHXM",
    url: "https://www.youtube.com/watch?v=yY3NSezaHXM",
    topic: "Yapay Zekânın Toplumsal Sürdürülebilirliğe Etkisi",
    program: "BloombergHT — Yapay Zeka Merkezi",
    date: "2024-10-18",
  },
  {
    id: "Fm8YHyP5qvA",
    url: "https://www.youtube.com/watch?v=Fm8YHyP5qvA",
    topic: "Yapay Zekâ, Finans ve Teknoloji",
    program: "Finansal Teknoloji",
    date: "2024-06-27",
  },
  {
    id: "WARdJ3I-gM0",
    url: "https://www.youtube.com/watch?v=WARdJ3I-gM0",
    topic: "Sürdürülebilirlik İletişimi ile Etki",
    program: "HBR Türkiye — Sistem Dönüşümü ve Etki, Bölüm 12",
    date: "2024-01-03",
  },
  {
    id: "Xtj_YUUeoBw",
    url: "https://www.youtube.com/watch?v=Xtj_YUUeoBw",
    topic: "Yaşanabilir Dünya",
    program: "EKOTÜRK TV — Sibel Topaloğlu ile",
    date: "2024-01-07",
  },
  {
    id: "ZMOJgLmlibk",
    url: "https://www.youtube.com/watch?v=ZMOJgLmlibk",
    topic: "Sürdürülebilirlik ve Etki",
    program: "Marketing Türkiye — XCO'22 (Yapı Kredi)",
    date: "2022-11-03",
  },
  {
    id: "JIBCPW7c07Q",
    url: "https://www.youtube.com/watch?v=JIBCPW7c07Q",
    topic: "Soyut Şeyler Ekonomisi",
    program: "EKOTÜRK TV — A. Selim Tuncer ile",
    date: "2023-06-13",
  },
].sort((a, b) => (a.date < b.date ? 1 : -1));

export function formatTalkDate(iso: string, lang: "tr" | "en" = "tr") {
  const d = new Date(iso + "T00:00:00Z");
  return d.toLocaleDateString(lang === "tr" ? "tr-TR" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}
